import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Package, Client, Tenant } from '../models';
import { MasterService } from '../../../base-classes/master-service';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class FuntionalAreaService extends MasterService<Package> {
   
    constructor(http: HttpClient) {
        super(http, `${environment.apiUrl}/functional-areas`);
        this.http = http;
    }

    // Get all functional areas
    getAllFunctionalAreas(): Observable<any[]> {
        return this.http.get<any[]>(`${environment.apiUrl}/functional-areas/user-functional-areas`);
    }

    // Create/update new functional area
    saveFunctionalArea(data: any): Observable<any> {
        return this.http.post<any>(`${environment.apiUrl}/functional-areas`, data);
    }

    // Delete functional area
    deleteFunctionalArea(id: string): Observable<void> {
        return this.http.delete<void>(`${environment.apiUrl}/functional-areas/${id}`);
    }
}